/**
 * 获取与预约项相应的surplusCount原始数据
 * @param surplusData 接口返回的result数据
 * @param option_id 预约项目id
 * @returns 
 */
export const getOptionData = (surplusData, option_id) =>
    surplusData?.find(item => item?.option_id === option_id) || null

/**
 * 修改Table列表行数据的方法
 * @param id rowData.id
 * @param obj { [key]: value }要修改的行数据的对象
 * @param setState useState的set方法
 */
export const onChangeRowData = (id, obj, setState) => {
    setState((state) =>
        state.map((item) => {
            if (item.id === id) {
                return { ...item, ...obj };
            }
            return item;
        })
    );
}

/**
 * Table列表项中 获取贵宾休息室，导购大使，代客泊车的时间和数量,以及次数
 * - 调用fetchSubscribeSurplus方法
 * @param fetch fetchSubscribeSurplus的方法
 * @param rowData 行数据
 * @param option_id 预约项目id
 * @param setState useState的set方法
 */
export const getSubscribeSurplusCount = (fetch, rowData, option_id, setState) => {
    fetch?.(rowData?.date).then((res) => {
        const surplusData = res?.option || [];
        const optionData = getOptionData(surplusData, option_id);
        const surplusCount = {
            timeSlot:
                optionData?.time_data?.map((time) => {
                    return {
                        value: time?.number,
                        label: time?.time_slot,
                    };
                }) || [],
            content: new Array(Number(optionData?.content || 0))
                .fill(null)
                .map((value, index) => {
                    return {
                        value: `${index + 1}`,
                        label: `${index + 1}人`,
                    };
                }),
            contentMax: optionData?.content || 1,
        };
        onChangeRowData?.(rowData?.id, { surplusCount }, setState);
    });
}